export default "__VITE_ASSET__D5epj8cM__"